
define('tmpl!core/templates/webidl-contiguous/multiline-comment.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlSectionComment\'>{{idn indent}}/*{{firstLine}}\n{{#each innerLine}}{{idn ../indent}}{{this}}\n{{/each}}{{idn indent}}{{lastLine}}*/</span>\n');});

